import React from 'react';

const LoaderInlineContent = ({ length }) => (
    <span className='loader-inline-content' style={{ '--length': length }}>
    </span>
);

export default LoaderInlineContent;